module.exports = __webpack_public_path__ + "img/Library Document.f59f3ddf.svg";